import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddSellerRes } from "./helper";

const requestConfig = { headers: { "content-type": "multipart/form-data" } };

const addSeller = async (data: SellerReqT) =>
  axios.post(Routes.ADD_SELLER, data, requestConfig);

export const useAddSeller = () =>
  useMutation({
    mutationKey: [Keys.ADD_SELLER_MUT],
    mutationFn: addSeller,
    onSuccess: onAddSellerRes,
  });
